import { Box, Grid, Paper, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { CustomStepper } from '../../components/CustomStepper';
import { CustomStepperBar } from '../../components/CustomStepperBar';
import { FormBotaoRosa } from '../../components/FormBotaoRosa';
import { Formulario } from '../../components/Formulario';
import { ConfirmacaoCadastro } from '../../components/ConfirmacaoCadastro';

export function SignUp() {
  const [itemAtivo, setItemAtivo] = useState(0);
  const navigate = useNavigate();

  function trocarItemAtivo() {
    setItemAtivo((itemAtivo) => itemAtivo + 1);
  };

  return (
    <>
      <Grid
        container
        component='main'
        sx={{ height: '100vh', backgroundColor: '#F8F8F9', }}
      >
        <Grid
          item
          xs={false}
          sm={5}
          md={4}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            px: '50px',
            backgroundColor: '#F0F0F5',
          }}
        >
          <CustomStepper itemAtivo={itemAtivo} />
        </Grid>

        <Grid
          item
          xs={12}
          sm={7}
          md={8}
          component={Paper}
          elevation={0}
          square
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: '#F8F8F9',
          }}
        >
          {itemAtivo !== 2 ? (
            <Box
              sx={{
                mt: '210px',
                mx: 4,
                width: '355px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography
                component='h1'
                variant='h5'
                sx={{
                  mb: '32px',
                  fontFamily: 'Montserrat',
                  fontWeight: 700
                }}
              >
                {itemAtivo === 0 ? 'Adicione seus dados' : 'Escolha uma senha'}
              </Typography>

              <Formulario
                itemAtivo={itemAtivo}
                setItemAtivo={setItemAtivo}
                trocarItemAtivo={trocarItemAtivo}
              />
            </Box>
          ) : (
            <>
              <ConfirmacaoCadastro />

              <FormBotaoRosa
                type='button'
                variant='contained'
                onClick={() => navigate('/')}
              >
                Ir para Login
              </FormBotaoRosa>
            </>
          )}

          <CustomStepperBar itemAtivo={itemAtivo} setItemAtivo={setItemAtivo} />
        </Grid>
      </Grid>
    </>
  );
};
